<template>
  <nav id="up-nav-bar" class="bg-slate-100 border-b border-neutral-200 h-14">
    <ul id="up-nav-bar__options" class="flex gap-7 ml-5">
      <slot name="navbarOptions" />
    </ul>
    <slot name="navbarDropdown" />
    <slot name="breadCrumbs" />
  </nav>
</template>
<script setup lang="ts"></script>
